// 角色 0：普通用户，1：机构内部管理员，2：超级管理员
export enum Role {
  User = 0,
  Manager = 1,
  Administrator = 2,
}

export enum Gender {
  Unknown = 0,
  Male = 1,
  Female = 2,
}

export const GenderOptions = [Gender.Male, Gender.Female, Gender.Unknown]

export const GenderNames = ['未知', '男', '女']

export const SexNames = ['female', 'male', 'female']

export function getGenderName(gender = 0): string {
  if (gender < 0 || gender >= GenderNames.length) {
    return ''
  }
  return GenderNames[gender]
}

export function getSexName(gender: Gender): string {
  if (gender < 0 || gender >= GenderNames.length) {
    return ''
  }
  return SexNames[gender]
}

// 岗位类别 0护士 1医生  2库房管理员 3柜台 5:药师，6:医技，7:理疗师，8:助理 16:盲人病历
export enum StationCategory {
  Nurse = 0,
  DoctorOrPharmacist = 1,
  Warehouse = 2,
  Count = 3,
  Counselor = 4,
  ASeniorPharmacist = 5,
  MedicalTechnician = 6,
  Physiotherapists = 7,
  Assistant = 8,
  Service = 9,
  Medicament = 10,
  HospitalGuide = 11,
  Operation = 12,
  Cashier = 13,
  GroupLeader = 14,
  GeneralManager = 15,
  MRMedical = 16,
  HygieneMaintenance = 17, // 保育员
  HygieneManager = 18, // 饮用水管理员
  HygieneMaintenanceManager = 19, // 饮用水维保员
}

export const StationCategories = [
  StationCategory.DoctorOrPharmacist,
  StationCategory.Nurse,
  StationCategory.Warehouse,
  StationCategory.Count,
  StationCategory.Counselor,
  StationCategory.ASeniorPharmacist,
  StationCategory.MedicalTechnician,
  StationCategory.Physiotherapists,
  StationCategory.Assistant,
  StationCategory.Service,
  StationCategory.Medicament,
  StationCategory.HospitalGuide,
  StationCategory.Operation,
  StationCategory.Cashier,
  StationCategory.GroupLeader,
  StationCategory.GeneralManager,
]

//饮用水岗位类别
export const HygieneStationCategories = [
  StationCategory.DoctorOrPharmacist,
  StationCategory.Nurse,
  StationCategory.Warehouse,
  StationCategory.HygieneMaintenance,
  StationCategory.HygieneManager,
  StationCategory.HygieneMaintenanceManager,
]

export const StationCategoryNames = [
  '护士',
  '医生',
  '库房管理员',
  '柜台',
  '咨询师',
  '药师',
  '医技',
  '理疗师',
  '助理',
  '客服',
  '药剂',
  '导诊',
  '运营',
  '出纳',
  '组长',
  '总经理',
  '盲人病历',
  '保育员',
  '饮用水管理员',
  '饮用水维保员'
]

export function getStationCategoryName(category: StationCategory): string {
  if (category < 0 || category >= StationCategoryNames.length) {
    return ''
  }
  return StationCategoryNames[category]
}

export enum StationProperty {
  OnJob = 0,
  Contract = 1,
}

export const StationProperties = [
  StationProperty.OnJob,
  StationProperty.Contract,
]

export function getStationPropertyName(property: StationProperty): string {
  if (property == StationProperty.OnJob) {
    return '行政在职'
  } else if (property == StationProperty.Contract) {
    return '行政合同'
  }
  return ''
}

export enum JobTitleCategory {
  ZLZYYS = '助理执业医师',
  ZYYS = '执业医师',
  ZZYS = '主治医师',
  FZRYSS = '副主任医师',
  ZRYSS = '主任医师',

  YS = '药士',
  YSS = '药师',
  ZGYS = '主管药师',
  FZRYS = '副主任药师',
  ZRYS = '主任药师',

  HS = '护士',
  HSS = '护师',
  ZGHS = '主管护师',
  FZRHS = '副主任护师',
  ZRHS = '主任护师',

  JS = '技士',
  JSS = '技师',
  ZGJS = '主管技师',
  FZRJS = '副主任技师',
  ZRJS = '主任技师',
}

// 医师
export const YSSJobTitleCategoris = [
  JobTitleCategory.ZLZYYS,
  JobTitleCategory.ZYYS,
  JobTitleCategory.ZZYS,
  JobTitleCategory.FZRYSS,
  JobTitleCategory.ZRYSS,
]

// 药师
export const YSJobTitleCategoris = [
  JobTitleCategory.YS,
  JobTitleCategory.YSS,
  JobTitleCategory.ZGYS,
  JobTitleCategory.FZRYS,
  JobTitleCategory.ZRYS,
]

// 护士
export const HSJobTitleCategoris = [
  JobTitleCategory.HS,
  JobTitleCategory.HSS,
  JobTitleCategory.ZGHS,
  JobTitleCategory.FZRHS,
  JobTitleCategory.ZRHS,
]

// 医技
export const YJJobTitleCategoris = [
  JobTitleCategory.JS,
  JobTitleCategory.JSS,
  JobTitleCategory.ZGJS,
  JobTitleCategory.FZRJS,
  JobTitleCategory.ZRJS,
]

export function getJobTitleName(JobTitle: JobTitleCategory) {
  switch (JobTitle) {
    case '助理执业医师':
      return '助理执业医师'
    case '执业医师':
      return '执业医师'
    case '主治医师':
      return '主治医师'
    case '副主任医师':
      return '副主任医师'
    case '主任医师':
      return '主任医师'

    case '药士':
      return '药士'
    case '药师':
      return '药师'
    case '主管药师':
      return '主管药师'
    case '副主任药师':
      return '副主任药师'
    case '主任药师':
      return '主任药师'
      
    case '护士':
      return '护士'
    case '护师':
      return '护师'
    case '主管护师':
      return '主管护师'
    case '副主任护师':
      return '副主任护师'
    case '主任护师':
      return '主任护师'

    case '技士':
      return '技士'
    case '技师':
      return '技师'
    case '主管技师':
      return '主管技师'
    case '副主任技师':
      return '副主任技师'
    case '主任技师':
      return '主任技师'
    default:
      break
  }
}
export interface User {
  auditPermissionsFlag: number
  id: string
  alipayUserId: string
  name: string
  gender: Gender
  phone: string
  role: Role
  password: string
  mnemonicCode: string
  state: number
  stationCategory: StationCategory
  stationProperty: StationProperty
  departmentId: string
  departmentName: string
  outpatientId: string
  outpatientName: string
  doctorCode: string
  email: string
  identityCard: string
  countryCode: string
  createTime: string
  innerDepartmentId: string
  innerDepartmentName: string
  outpatientDepartmentId: string
  outpatientDepartmentName: string
  practiceCertificate: string
  qualificationCertificate: string
  realname: string
  sex: string
  status: string
  diagnoses?: string
  prescription?: string
  jobTitle?: string
  headPhoto?: any
  cwcaOptId?: string
  isAskMedicine?: number
}

export interface AppointmentDoctorsRes {
  doctorId: string
  doctorName: string
}

export function fromJson(json: any): User {
  return {
    id: json.id?.toString() || '',
    name: json.realname,
    gender: json.sex,
    phone: json.phone,
    realname: json.realname,
    alipayUserId: json.alipayUserId || '',
    role: json.role,
    password: '',
    mnemonicCode: json.mnemonicCode,
    state: json.state,
    stationCategory: json.stationCategory,
    stationProperty: json.stationProperty,
    departmentId: json.innerDepartmentId?.toString(),
    departmentName: json.innerDepartmentName,
    outpatientId: json.outpatientDepartmentId?.toString(),
    outpatientName: json.outpatientDepartmentName,
    doctorCode: json.doctorCode,
    email: json.email,
    identityCard: json.identityCard,
    countryCode: json.countryCode,
    createTime: json.createTime,
    innerDepartmentId: json.innerDepartmentId,
    innerDepartmentName: json.innerDepartmentName,
    outpatientDepartmentId: json.outpatientDepartmentId,
    outpatientDepartmentName: json.outpatientDepartmentName,
    practiceCertificate: json.practiceCertificate,
    qualificationCertificate: json.qualificationCertificate,
    sex: json.sex,
    status: json.status,
    diagnoses: json.diagnoses,
    prescription: json.prescription,
    jobTitle: json.jobTitle,
    headPhoto: json.headPhoto,
    cwcaOptId: json.cwcaOptId,
    isAskMedicine: json.isAskMedicine,
    auditPermissionsFlag: json.auditPermissionsFlag,
  }
}

export function toJson(user: User): any {
  return {
    id: user.id,
    realname: user.name,
    sex: user.gender,
    phone: user.phone,
    password: user.password,
    mnemonicCode: user.mnemonicCode,
    stationCategory: user.stationCategory,
    stationProperty: user.stationProperty,
    innerDepartmentId: user.departmentId,
    innerDepartmentName: user.departmentName,
    outpatientDepartmentId: user.outpatientId,
    outpatientDepartmentName: user.outpatientName,
    practiceCertificate: user.practiceCertificate,
    doctorCode: user.doctorCode,
    tenantRole: user.role,
    name: user.name,
    gender: user.gender,
    role: user.role,
    email: user.email,
    identityCard: user.identityCard,
    countryCode: user.countryCode,
    createTime: user.createTime,
    qualificationCertificate: user.qualificationCertificate,
    status: user.status,
    state: user.state,
    departmentId: user.departmentId,
    departmentName: user.departmentName,
    outpatientId: user.outpatientId,
    diagnoses: user.diagnoses,
    prescription: user.prescription,
    jobTitle: user.jobTitle,
    auditPermissionsFlag: user.auditPermissionsFlag,
  }
}
